import { Component, Input } from '@angular/core';
import { MilprReport } from '../../../_models/reports/milpr-report.model';

@Component({
    selector: 'milpr-report',
    templateUrl: 'milpr-report.component.html',
    styleUrls: ['milpr-report.component.css'],
    standalone: false
})
export class MilprReportComponent {
    @Input() report: MilprReport;

    /** SEMH rating order used by both the ILP/baseline and progress sections. */
    public semhLabels: Array<{ key: string, label: string }> = [
        { key: 'confidenceRating', label: 'Confidence' },
        { key: 'resilienceRating', label: 'Resilience' },
        { key: 'independenceRating', label: 'Independence' },
        { key: 'motivationRating', label: 'Motivation' },
        { key: 'selfRegulationRating', label: 'Self-regulation' }
    ];
}
